export default {

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth/getters.js